/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CaseDocument = {
    readonly id?: number;
    readonly lab_order_id?: number;
    readonly specimen_id?: number;
    name: string;
    /**
     * the category of document. E.g: 'Lab Requisition' or 'Doc Insurance'
     */
    category: CaseDocument.category;
    /**
     * current status of the case document
     */
    status?: CaseDocument.status;
    /**
     * document metadata parsed from WPL's order message
     */
    wpl_document_metadata?: any;
    /**
     * If true, this document will get attached to the final case report.
     */
    attach_to_case_report?: boolean;
    readonly created_at?: string;
}

export namespace CaseDocument {

    /**
     * the category of document. E.g: 'Lab Requisition' or 'Doc Insurance'
     */
    export enum category {
        CASE_REPORT = 'Case-Report',
        UNMERGED_CASE_REPORT = 'Unmerged-Case-Report',
        PREVIOUS_PATHOLOGY_REPORT = 'Previous-Pathology-Report',
        PRELIMINARY_REPORT = 'Preliminary-Report',
        UNMERGED_PRELIMINARY_REPORT = 'Unmerged-Preliminary-Report',
        CLINIC_NOTES = 'Clinic-Notes',
        CONSENT_FORM = 'Consent-Form',
        CONSULTATION_REPORT = 'Consultation-Report',
        DOC_CLINICAL = 'Doc-Clinical',
        DOC_INSURANCE = 'Doc-Insurance',
        DIF_REPORT = 'DIF-Report',
        EXTRADEPARTMENTAL_REPORT = 'Extradepartmental-Report',
        FISH_REPORT = 'Fish-Report',
        GROSS_DIAGRAM = 'Gross-Diagram',
        LAB_REPORT = 'Lab-Report',
        LAB_REQUISITION = 'Lab-Requisition',
        SENDOUT_REQUISITION = 'Sendout-Requisition',
        MOLECULAR_REPORT = 'Molecular-Report',
        PATIENT_DEMOGRAPHICS = 'Patient-Demographics',
        REQUISITION_FORM = 'Requisition-Form',
        LOOSE_DOCUMENT = 'Loose-Document',
        MATERIAL_REQUEST = 'Material-Request',
        SELF_PAY_ATTESTATION = 'Self-Pay-Attestation',
        INTERNAL_DOCUMENT = 'Internal-Document',
        INDIGENT_PATIENT_AGREEMENT_NOTICE = 'Indigent-Patient-Agreement-Notice',
        IHC_REPORT = 'IHC-Report',
        CASE_CORRECTION_REQUEST = 'Case-Correction-Request',
        CONSULT_LETTER = 'Consult-Letter',
        TICK_REPORT = 'Tick-Report',
        CASTLE_REPORT = 'Castle-Report',
        ISH_REPORT = 'ISH-Report',
        GROSS_SPECIMEN_PHOTO = 'Gross-Specimen-Photo',
        OTHER = 'Other',
    }

    /**
     * current status of the case document
     */
    export enum status {
        PENDING = 'pending',
        UPLOADED = 'uploaded',
    }

    export const pendingDocumentCategoryKeys = [
    "PREVIOUS_PATHOLOGY_REPORT",
    "CLINIC_NOTES",
    "CONSENT_FORM",
    "CONSULTATION_REPORT",
    "DIF_REPORT",
    "FISH_REPORT",
    "GROSS_DIAGRAM",
    "LAB_REPORT",
    "SENDOUT_REQUISITION",
    "MOLECULAR_REPORT",
    "PATIENT_DEMOGRAPHICS",
    "REQUISITION_FORM",
    "MATERIAL_REQUEST",
    "SELF_PAY_ATTESTATION",
    "INDIGENT_PATIENT_AGREEMENT_NOTICE",
    "IHC_REPORT",
    "CASE_CORRECTION_REQUEST",
    "CONSULT_LETTER",
    "TICK_REPORT",
    "CASTLE_REPORT",
    "ISH_REPORT",
    "GROSS_SPECIMEN_PHOTO",
    "OTHER",
    ] as const satisfies ReadonlyArray<keyof typeof CaseDocument.category>;

    export const pendingDocumentCategories = pendingDocumentCategoryKeys.map(
        key => CaseDocument.category[key]
    );

}
